/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `ACTIVE` - Active
 * * `MITIGATED` - Mitigated
 * * `RESOLVED` - Resolved
 * @export
 */
export const RiskStatusEnum = {
    Active: 'ACTIVE',
    Mitigated: 'MITIGATED',
    Resolved: 'RESOLVED'
} as const;
export type RiskStatusEnum = typeof RiskStatusEnum[keyof typeof RiskStatusEnum];


export function instanceOfRiskStatusEnum(value: any): boolean {
    for (const key in RiskStatusEnum) {
        if (Object.prototype.hasOwnProperty.call(RiskStatusEnum, key)) {
            if (RiskStatusEnum[key as keyof typeof RiskStatusEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RiskStatusEnumFromJSON(json: any): RiskStatusEnum {
    return RiskStatusEnumFromJSONTyped(json, false);
}

export function RiskStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): RiskStatusEnum {
    return json as RiskStatusEnum;
}

export function RiskStatusEnumToJSON(value?: RiskStatusEnum | null): any {
    return value as any;
}

export function RiskStatusEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): RiskStatusEnum {
    return value as RiskStatusEnum;
}

